import { Injectable, Inject } from '@angular/core';
import { PolicyAgentDO } from '../policyAgent.model';
import { PolicyClientDO } from '../policyClient.model';
import { PolicyCoverageDO } from '../policyCoverage.model';
import { PolicyPaymentDO } from '../payment.model';
import { PolicyPremiumSummaryDO } from '../policyPremiumSummary.model';
import { PolicyAdditionalFieldDO } from '../policyAdditionalField.model';
import { PolicyBeneficiaryDO } from '../policyBeneficiary.model';
import { PolicyTripDO } from '../policyTrip.model';
import { OtherPolicyDO } from '../otherPolicy.model';
import { PolicyPremiumBreakupDO } from '../PolicyPremiumBreakup.model';
import { BaseDO } from '../base.model';

export class PolicyDO extends BaseDO {
	// public leadRefNum:string;
	// public quotationRefNum:string;
	// public policyCovergeList:PolicyCoverageDO[];
	// public proposalClients:PolicyClientDO[];
	// public policyAgentList:PolicyAgentDO[];
	// //public proposalPayments:PolicyPaymentDO[];

	// public setProposalClients( proposalClients:PolicyClientDO[]){
	//   this.proposalClients = proposalClients;
	// }


	// public setPolicyCovergeList( proposalCoverages:PolicyCoverageDO[]){
	//   this.policyCovergeList = proposalCoverages;
	// }



	public id: Number = null;
	public leadRefNum: String = null;

	public quotationRefNum: String = null;

	public proposalRefNum: String = null;

	public proposalNum: String = null;


	public policyNum: String = null;

	public proposalEntryDt: Date = null;

	public proposalReceivedDt: Date = null;

	public proposalSignedDt: Date = null;

	public policyCommencementDt: Date = null;

	public policyExpiryDt: Date = null;

	public policyIssueDt: Date = null;

	public purposeOfInsuranceCd: String = null;

	public submissionModeCd: String = null;

	public policyTypeCd: String = null;

	public baseProductFamilyCd: String = null;

	public baseProductCd: String = null;

	public baseProductTypeCd: String = null;

	public productPlanOptionCd: String = null;

	public baseProductVersion: Number = null;

	public baseAgentId: String = null;

	public statusCd: String = null;

	public processStatusCd: String = null;

	public stageCd: String = null;

	public validationStatusCd: String = null;

	public uwDecisionCd: String = null;

	public uwDecisionValue: String = null;

	public uwDecisionDt: Date = null;

	public workFlowDecisionCd: String = null;

	public finalSumInsured: Number = null;

	public finalPremiumAmt: Number = null;

	public premiumStatusCd: String = null;

	public policyterm: Number = null;

	public ruleEffectiveDate: Number = null;

	public underwitingTypeCd: String = null;

	public ratingTypeCd: String = null;

	public coResponseCd: String = null;

	public primaryInsuredValue: Number = null;

	public estimatedPrimaryInsuredValue: Number = null;

	public totOtherInsurableValue: Number = null;

	public sumInsured: Number = null;

	public riskCategoryCd: String = null;

	public currencyCd: String = null;

	public promoCd: String = null;

	public proposalCoverages: PolicyCoverageDO[] = [];

	public policyAgentList: PolicyAgentDO[] = [];

	public proposalClients: PolicyClientDO[] = [];

	public proposalPayments: PolicyPaymentDO[] = [];

	public policyPremiumSummaryList: PolicyPremiumSummaryDO[] = [];

	public policyAdditionalFieldList: PolicyAdditionalFieldDO[] = [];

	public policyTripDO: PolicyTripDO = new PolicyTripDO();

	public policyBeneficiaryList: PolicyBeneficiaryDO[] = [];

	public otherPolicyList: OtherPolicyDO[] = [];

	public premiumBreakupList: PolicyPremiumBreakupDO[] = [];

	public dueDt: any = null;

	public getId() {
		return this.id;
	}
	public setId(id: Number) {
		this.id = id;
	}
	public getPolicyNum() {
		return this.policyNum;
	}
	public setPolicyNum(policyNum: String) {
		this.policyNum = policyNum;
	}
	public getPolicyIssueDt() {
		return this.policyIssueDt;
	}
	public setPolicyIssueDt(policyIssueDt: Date) {
		this.policyIssueDt = policyIssueDt;
	}
	public getProposalEntryDt() {
		return this.proposalEntryDt;
	}
	public setProposalEntryDt(proposalEntryDt: Date) {
		this.proposalEntryDt = proposalEntryDt;
	}
	public getProposalNum() {
		return this.proposalNum;
	}
	public setProposalNum(proposalNum: String) {
		this.proposalNum = proposalNum;
	}
	public getProposalReceivedDt() {
		return this.proposalReceivedDt;
	}
	public setProposalReceivedDt(proposalReceivedDt: Date) {
		this.proposalReceivedDt = proposalReceivedDt;
	}
	public getProposalSignedDt() {
		return this.proposalSignedDt;
	}
	public setProposalSignedDt(proposalSignedDt: Date) {
		this.proposalSignedDt = proposalSignedDt;
	}
	public getPolicyCommencementDt() {
		return this.policyCommencementDt;
	}
	public setPolicyCommencementDt(policyCommencementDt: Date) {
		this.policyCommencementDt = policyCommencementDt;
	}
	public getPolicyExpiryDt() {
		return this.policyExpiryDt;
	}
	public setPolicyExpiryDt(policyExpiryDt: Date) {
		this.policyExpiryDt = policyExpiryDt;
	}
	public getPurposeOfInsuranceCd() {
		return this.purposeOfInsuranceCd;
	}
	public setPurposeOfInsuranceCd(purposeOfInsuranceCd: String) {
		this.purposeOfInsuranceCd = purposeOfInsuranceCd;
	}
	public getQuotationRefNum() {
		return this.quotationRefNum;
	}
	public setQuotationRefNum(quotationRefNum: String) {
		this.quotationRefNum = quotationRefNum;
	}
	public getSubmissionModeCd() {
		return this.submissionModeCd;
	}
	public setSubmissionModeCd(submissionModeCd: String) {
		this.submissionModeCd = submissionModeCd;
	}
	public getProposalRefNum() {
		return this.proposalRefNum;
	}
	public setProposalRefNum(proposalRefNum: String) {
		this.proposalRefNum = proposalRefNum;
	}
	public getBaseProductFamilyCd() {
		return this.baseProductFamilyCd;
	}
	public setBaseProductFamilyCd(baseProductFamilyCd: String) {
		this.baseProductFamilyCd = baseProductFamilyCd;
	}
	public getBaseProductCd() {
		return this.baseProductCd;
	}
	public setBaseProductCd(baseProductCd: String) {
		this.baseProductCd = baseProductCd;
	}
	public getBaseProductTypeCd() {
		return this.baseProductTypeCd;
	}
	public setBaseProductTypeCd(baseProductTypeCd: String) {
		this.baseProductTypeCd = baseProductTypeCd;
	}
	public getProductPlanOptionCd() {
		return this.productPlanOptionCd;
	}
	public setProductPlanOptionCd(productPlanOptionCd: String) {
		this.productPlanOptionCd = productPlanOptionCd;
	}
	public getPolicyTypeCd() {
		return this.policyTypeCd;
	}
	public setPolicyTypeCd(policyTypeCd: String) {
		this.policyTypeCd = policyTypeCd;
	}

	public getStatusCd() {
		return this.statusCd;
	}
	public setStatusCd(statusCd: String) {
		this.statusCd = statusCd;
	}
	public getProcessStatusCd() {
		return this.processStatusCd;
	}
	public setProcessStatusCd(processStatusCd: String) {
		this.processStatusCd = processStatusCd;
	}
	public getStageCd() {
		return this.stageCd;
	}
	public setStageCd(stageCd: String) {
		this.stageCd = stageCd;
	}
	public getUwDecisionCd() {
		return this.uwDecisionCd;
	}
	public setUwDecisionCd(uwDecisionCd: String) {
		this.uwDecisionCd = uwDecisionCd;
	}
	public getUwDecisionValue() {
		return this.uwDecisionValue;
	}
	public setUwDecisionValue(uwDecisionValue: String) {
		this.uwDecisionValue = uwDecisionValue;
	}
	public getUwDecisionDt() {
		return this.uwDecisionDt;
	}
	public setUwDecisionDt(uwDecisionDt: Date) {
		this.uwDecisionDt = uwDecisionDt;
	}
	public getWorkFlowDecisionCd() {
		return this.workFlowDecisionCd;
	}
	public setWorkFlowDecisionCd(workFlowDecisionCd: String) {
		this.workFlowDecisionCd = workFlowDecisionCd;
	}
	public getPremiumStatusCd() {
		return this.premiumStatusCd;
	}
	public setPremiumStatusCd(premiumStatusCd: String) {
		this.premiumStatusCd = premiumStatusCd;
	}
	public getValidationStatusCd() {
		return this.validationStatusCd;
	}
	public setValidationStatusCd(validationStatusCd: String) {
		this.validationStatusCd = validationStatusCd;
	}
	public getProposalCoverages() {
		return this.proposalCoverages;
	}
	public setProposalCoverages(proposalCoverages: PolicyCoverageDO[]) {
		this.proposalCoverages = proposalCoverages;
	}
	public getPolicyPremiumSummaryList() {
		return this.policyPremiumSummaryList;
	}
	public setPolicyPremiumSummaryList(policyPremiumSummaryList: PolicyPremiumSummaryDO[]) {
		this.policyPremiumSummaryList = policyPremiumSummaryList;
	}
	public getPolicyAgentList() {
		return this.policyAgentList;
	}
	public setPolicyAgentList(policyAgentList: PolicyAgentDO[]) {
		this.policyAgentList = policyAgentList;
	}
	public getProposalPayments() {
		return this.proposalPayments;
	}
	public setProposalPayments(proposalPayments: PolicyPaymentDO[]) {
		this.proposalPayments = proposalPayments;
	}
	public getProposalClients() {
		return this.proposalClients;
	}
	public setProposalClients(proposalClients: PolicyClientDO[]) {
		this.proposalClients = proposalClients;
	}
	public getBaseProductVersion() {
		return this.baseProductVersion;
	}
	public setBaseProductVersion(baseProductVersion: Number) {
		this.baseProductVersion = baseProductVersion;
	}
	public getPolicyAdditionalFieldList() {
		return this.policyAdditionalFieldList;
	}
	public setPolicyAdditionalFieldList(policyAdditionalFieldList: any[]) {
		this.policyAdditionalFieldList = policyAdditionalFieldList;
	}

	public getFinalSumInsured() {
		return this.finalSumInsured;
	}
	public setFinalSumInsured(finalSumInsured: Number) {
		this.finalSumInsured = finalSumInsured;
	}

	public getRuleEffectiveDate() {
		return this.ruleEffectiveDate;
	}
	public setRuleEffectiveDate(ruleEffectiveDate: Number) {
		this.ruleEffectiveDate = ruleEffectiveDate;
	}

	// public  getObjectName() {
	// 	return this.PolicyDO.class.getSimpleName();
	// }

	public getFinalPremium() {
		return this.finalPremiumAmt;
	}
	public setFinalPremium(finalPremiumAmt: Number) {
		this.finalPremiumAmt = finalPremiumAmt;
	}

	public getPolicyterm() {
		return this.policyterm;
	}
	public setPolicyterm(policyterm: Number) {
		this.policyterm = policyterm;
	}
	public getBasePlan(): PolicyCoverageDO {

		let coverage = new PolicyCoverageDO();
		if (this.proposalCoverages != null && this.proposalCoverages.length > 0) {
			for (let tempCoverageDO of this.proposalCoverages) {
				//			if("BASEPLAN".equals.getPlanTypeCd())){
				//				return this;
				//			}

				if (tempCoverageDO.getPlanTypeCd() != null && tempCoverageDO.getPlanTypeCd() == "BASEPLAN") {
					coverage = tempCoverageDO;
					return coverage;
				}
			}
		}

		return null;

	}
	public getLeadRefNum() {
		return this.leadRefNum;
	}
	public setLeadRefNum(leadRefNum: String) {
		this.leadRefNum = leadRefNum;
	}
	public getBaseAgentId() {
		return this.baseAgentId;
	}
	public setBaseAgentId(baseAgentId: String) {
		this.baseAgentId = baseAgentId;
	}

	public getUnderwitingTypeCd() {
		return this.underwitingTypeCd;
	}
	public setUnderwitingTypeCd(underwitingTypeCd: String) {
		this.underwitingTypeCd = underwitingTypeCd;
	}
	public getPolicyTripDO() {
		return this.policyTripDO;
	}
	public setPolicyTripDO(policyTripDO: any) {
		this.policyTripDO = policyTripDO;
	}
	public getPolicyBeneficiaryList() {
		return this.policyBeneficiaryList;
	}
	public setPolicyBeneficiaryList(policyBeneficiaryList: any) {
		this.policyBeneficiaryList = policyBeneficiaryList;
	}

	public getDueDt() {
		return this.dueDt;
	}

	public setDueDt(dueDt: any) {
		this.dueDt = dueDt;
	}
}

export class ClaimPolicyDO {
	provider = null;
	policyNum = null;
	baseProductFamilyCd = null;
	baseProductCd = null;
	baseProductTypeCd = null;
	sumInsured = null;
	commencementDt = null;
	policyIssueDt = null;
	expiryDt = null;
	statusCd = null;
	premiumPaid = null;
	remarks = null;
	baseAgentId = null;
	policyAge = null;
	premPaidTillDt = null;
	reinstatementDt = null;
	earlyClaimFl = null;
	policyAgeInMonths = null;
	riskCategoryCd = null;
	policyTypeCd = null;
}
//}
